(ns app.trash.views
  (:require [app.components.buttons.views :as buttons]
            [app.components.headers.views :refer [header]]
            [app.components.icons.views :refer [arrow-left-icon folder-icon
                                                form-icon new-folder-icon delete-icon empty-folder-icon
                                                product-icon trash-big-icon]]
            [app.components.pop-ups.views :refer [mui-snackbar
                                                  mutliselect-actions-pop-up pop-up]]
            [app.components.tables.views :refer [basic-table-with-checkbox]]
            [app.dashboard.events :as devents]
            [app.events :as events]
            [app.members.styles :refer [settings-panel]]
            [app.products-section.views :refer [deleted-products-section
                                                form-link product-link] :as product-section]
            [app.routes :as routes]
            [app.styles :refer [folder-header-style]]
            [app.subs :as subs]
            [re-com.core :as re-com :refer [at h-box v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent.core  :as reagent :refer [atom]]))

(defn empty-trash [w-id empty-trash-notification deleted-assets]
  (re-posh/dispatch [::devents/delete-permanently  {:workspace-id w-id :assets-id deleted-assets}])
  (reset! empty-trash-notification true))

(defn delete-selected-permanently [w-id assets-selected empty-trash-notification] 
    (re-posh/dispatch [::devents/delete-permanently  {:workspace-id w-id :assets-id @assets-selected}])
    (reset! empty-trash-notification true))

(defn restore-from-trash [w-id assets-selected restore-notification] 
    (re-posh/dispatch [::devents/restore  {:workspace-id w-id :assets-id @assets-selected :folder-id nil}])
    (reset! restore-notification true))

(defn unshow-popover [selected?]
  (reset! selected? false))

(defn deleted-folder-header []
  (reagent/create-class
   {:reagent-render
    (fn [deleted-selected-folder-name workspace-id]
      [h-box
       :src (at)
       :justify :between
       :children [[header {:label (if (= deleted-selected-folder-name "") "Untitled" deleted-selected-folder-name)
                           :type :title :size :large :style (folder-header-style deleted-selected-folder-name)}]]])}))

(defn empty-deleted-folder-view [workspace-id selected-folder-id empty-trash-notification]
  (let [asset-selected (reagent/atom [{:type :folder
                                       :id selected-folder-id}])]
    (fn []
      [v-box
       :src (at)
       :justify :center
       :align :center
       :height "calc(100% - 120px)"
       :gap "17px"
       :children [[empty-folder-icon {:size "260px"}]
                  [header {:label "This deleted folder is empty 😢" :type :title :size :large}]
                  [:div {:id "create-new-project-button"}
                   [buttons/button {:action :warning :type :secondary
                                    :title "Permanently delete"
                                    :size :medium
                                    :icon delete-icon
                                    :onClick #(do (delete-selected-permanently workspace-id asset-selected empty-trash-notification)
                                                  (re-frame/dispatch [::events/navigate [:trash-view :id workspace-id]]))}]]]])))

(defn deleted-folders-panel [workspace-id]
  (let [data @(re-posh/subscribe [::subs/deleted-selected-folder-data])
        selected-folder-id (:deleted-selected-folder/id data)
        empty-trash-notification (reagent/atom false)] 
    (fn [] 
      [v-box
       :src (at)
       :size "auto"
       :gap "24px"
       :style {:overflow-y "auto"
               :padding "0px 20px"}
       :children [[h-box
                   :src (at)
                   :gap "16px"
                   :align :start
                   :children [[buttons/icon-button {:icon arrow-left-icon :style {:height "36px" :width "36px" :padding-top "5px"} :onClick #(re-frame/dispatch [::events/navigate [:trash-view :id workspace-id]])}]
                              [deleted-folder-header (:deleted-selected-folder/name data) workspace-id]]]
                  (if (and (empty? (:deleted-selected-folder/projects data)) (empty? (:deleted-selected-folder/forms data)))
                    [empty-deleted-folder-view workspace-id selected-folder-id empty-trash-notification]
                    [v-box
                     :src (at)
                     :gap "24px"
                     :children [[deleted-products-section workspace-id selected-folder-id data "Products" :product #(re-posh/dispatch [::devents/create-product {:workspace-id workspace-id :folder-id selected-folder-id}])]
                                [deleted-products-section workspace-id selected-folder-id data "Forms" :form #(re-posh/dispatch [::devents/create-form {:workspace-id workspace-id :folder-id selected-folder-id}])]]])]])))

(defn alter-data-for-table [data workspace-name w-id]
  (map  #(-> %
             (assoc :from (if (= "folder" (% :type))
                            @workspace-name (% :folder_name)))
             (assoc :icon (if (= "folder" (% :type)) [folder-icon {:size 20}]
                              (if (= "product" (% :type))
                                [product-icon {:size 20}]
                                [form-icon {:size 20}])))
             (assoc :link (if (= "folder" (% :type))
                            (fn [_]
                              (re-posh/dispatch [::devents/add-deleted-selected-folder {:deleted-selected-folder/id (% :id)
                                                                                        :deleted-selected-folder/name (% :name)}])
                              (re-frame/dispatch [::events/navigate [:deleted-folder-view :id w-id :folder-id (% :id)]]))
                            (if (= "product" (% :type))
                              (product-link {:template_id (% :secondary_id) :workspace-id w-id :folder-id (% :folder_id)})
                              (form-link {:id (% :id) :workspace-id w-id :folder-id (% :folder_id)}))))) data))

(defn empty-trash-page []
  [v-box
   :src (at)
   :justify :center
   :align :center
   :height "calc(100% - 60px)"
   :gap "17px"
   :children
   [[trash-big-icon]
    [header {:label "Oh-oh" :type :x-large :size :bold}]
    [header {:label "Trash is empty. Nothing to see here" :type :x-large :size :bold}]]])


(defn trash-view-panel [w-id]
  (let [deleted-assets  (re-posh/subscribe [::subs/deleted-selected-workspace-data])
        workspace-name (re-posh/subscribe [::subs/selected-workspace-name])]
    (fn []
      (let [selected? (reagent/atom false)
            empty-trash-notification (reagent/atom false)
            restore-notification (reagent/atom false)
            assets-selected (reagent/atom '())
            selected-all-ticked? (reagent/atom false)
            global-ticked? (reagent/atom false)
            show-delete-warning (reagent/atom false)
            context-menu (reagent/atom nil)
            show-context-menu? (reagent/atom false)
            right-clicked-item (reagent/atom [{:type (:type @context-menu)
                                               :id (:id @context-menu)}])
            data (reagent/atom (alter-data-for-table (:deleted-selected-workspace/assets @deleted-assets) workspace-name w-id))
            array-of-ticked (reagent/atom (mapv (fn [e] {:id (:id e) :ticked false}) @data))
            actions [{:title "Restore" :action #(do (restore-from-trash w-id assets-selected restore-notification)
                                                    (unshow-popover selected?)
                                                    (reset! array-of-ticked (mapv (fn [x] (update x :ticked (fn [e]
                                                                                                              false))) @array-of-ticked)))}
                     {:title "Delete permanently"  :action #(do
                                                              (delete-selected-permanently w-id assets-selected empty-trash-notification)
                                                              (unshow-popover selected?)
                                                              (reset! array-of-ticked (mapv (fn [x] (update x :ticked (fn [e]
                                                                                                                        false))) @array-of-ticked)))}]
            individual-asset-actions [{:title "View"  :action #(do
                                                                 (if (= "folder" (:type @context-menu))
                                                                   ((:link @context-menu))
                                                                   (js/window.location.assign (:link @context-menu)))
                                                                 (reset! context-menu nil)
                                                                 (reset! right-clicked-item nil)
                                                                 (swap! show-context-menu? not))}
                                      {:title "Restore" :action #(do (restore-from-trash w-id right-clicked-item restore-notification)
                                                                     (unshow-popover selected?)
                                                                     (swap! show-context-menu? not)
                                                                     (reset! context-menu nil)
                                                                     (reset! right-clicked-item nil)
                                                                     (reset! array-of-ticked (mapv (fn [x] (update x :ticked (fn [e]
                                                                                                                               false))) @array-of-ticked)))}
                                      {:title "Delete permanently"  :action #(do
                                                                               (delete-selected-permanently w-id right-clicked-item empty-trash-notification)
                                                                               (unshow-popover selected?)
                                                                               (reset! context-menu nil)
                                                                               (reset! right-clicked-item nil)
                                                                               (swap! show-context-menu? not)
                                                                               (reset! array-of-ticked (mapv (fn [x] (update x :ticked (fn [e]
                                                                                                                                         false))) @array-of-ticked)))}]]
        (fn []  @array-of-ticked @assets-selected
          (when (< (count @array-of-ticked) (count (:deleted-selected-workspace/assets @deleted-assets)))
            (reset! array-of-ticked (mapv (fn [e] {:id (:id e) :ticked  false}) (:deleted-selected-workspace/assets @deleted-assets))))
          (if (= 0 (count (:deleted-selected-workspace/assets @deleted-assets)))
            [empty-trash-page]
            [v-box
             :src      (at)
             :height "100vh"
             :size "auto"
             :class (settings-panel)
             :children [[h-box
                         :justify :between
                         :children [[h-box
                                     :gap "20px"
                                     :children [[buttons/button {:action :warning :type :secondary :title "Empty Trash" :size :medium :attr {:aria-describedby "empty-trash-button"} :onClick #(do (reset! show-delete-warning true)
                                                                                                                                                                                                   (reset! selected? false))}]
                                                (when @show-delete-warning [pop-up {:main-text (str "WARNING") :sub-text "This action can not be undone." :on-cancel #(do (reset! show-delete-warning false)
                                                                                                                                                                          (reset! selected? true))
                                                                                    :on-confirm #(do (empty-trash w-id empty-trash-notification (:deleted-selected-workspace/assets @deleted-assets))
                                                                                                     (reset! show-delete-warning false))
                                                                                    :cancel-button-text "Cancel" :confirm-button-text "Empty Trash"}])]]]]
                        [basic-table-with-checkbox {:data (reagent/atom (alter-data-for-table (:deleted-selected-workspace/assets @deleted-assets) workspace-name w-id))
                                                    :unfiltered-data (reagent/atom (alter-data-for-table (:deleted-selected-workspace/assets @deleted-assets) workspace-name w-id))
                                                    :columns {:names ["Name" "Deleted From" "On"] :values [:name :from :deleted_at] :values-sort [:name :from :deleted_at]}
                                                    :assets-selected assets-selected
                                                    :selected-all-ticked? selected-all-ticked?
                                                    :selected? selected?
                                                    :array-of-ticked array-of-ticked
                                                    :actions individual-asset-actions
                                                    :context-menu context-menu
                                                    :show-context-menu? show-context-menu?
                                                    :right-clicked-item right-clicked-item}]
                        (when @empty-trash-notification [mui-snackbar {:main-text "You have permanently deleted the selected items in the trash." :open empty-trash-notification}])
                        (when @restore-notification [mui-snackbar {:main-text "The files you have selected have been safely restored." :open restore-notification}])
                        (when (seq @assets-selected) [mutliselect-actions-pop-up {:selected? selected?
                                                                                  :global-ticked? global-ticked?
                                                                                  :array-of-ticked array-of-ticked
                                                                                  :selected-all-ticked? selected-all-ticked?
                                                                                  :assets-selected assets-selected
                                                                                  :all-assets (:deleted-selected-workspace/assets @deleted-assets)
                                                                                  :actions actions}])]]))))))

(defmethod routes/panels :trash-view-panel [] [trash-view-panel])